import { AxiosResponse } from 'axios';
import { BlobDocumentReponse } from '../../Model/Dto/BlobDocument';
import { ModuleType } from '../../Model/Enum/BEE123Enums';
import { axiosCoreInstance } from '../AxiosCoreInterceptor';
import * as ApiUrls from './ApiUrl.Legislation';

export const LegislationService = {

    GetLegislationDocument: (name: string, legislationType: ModuleType, section: number): Promise<AxiosResponse<BlobDocumentReponse>>  => 
    axiosCoreInstance.get(ApiUrls.LegislationDocuments, {params: {section: section, type: legislationType, filename: name}}),
   
}